import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from "yup";
import { Typography, Box, alpha } from '@mui/material';
import { useDispatch } from 'react-redux';
import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive';
import InputComponent from 'src/components/shared/Form/Input';
import ButtonComponent from 'src/components/shared/Button';
import theme, { palette, shadows, typography } from 'src/config/theme';
import { useNavigate } from 'react-router-dom';
import { LoginContainer, InputTextComponent, LoginText, LoginTextContainer } from './Styles';

import { login } from '../../../../auth/store/authActions';

function LoginForm() {
  const dispatch = useDispatch();
  const { isDesktop } = useResponsive();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (data, { resetForm }) => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      dispatch(
        login(
          data,
          () => {
            toast.success("Login Successful");
            navigate('/public/onboards');
            setLoading(false);
            resolve();
          },
          (err) => {
            toast.error(err?.message || "Login failed");
            setLoading(false);
            reject(err);
          }
        )
      );
    });
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  return (
    <LoginContainer>
      <LoginTextContainer>
        <LoginText>
          Login
        </LoginText>

      </LoginTextContainer>


      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit: formikSubmit,
        }) => (

          <Form onSubmit={formikSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>


            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', height: '76px' }}>
              <Typography sx={{ ...typography.smallRegular, color: theme.palette.gery.black }}>
                Email
              </Typography>
              <InputTextComponent
                variant="outlined"
                name="email"
                fullWidth
                placeholder="Enter Email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}

              />
            </Box>


            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', height: '76px', marginBottom: '10px' }}>
              <Typography sx={{ ...typography.smallRegular, color: theme.palette.gery.black }}>
                Password
              </Typography>
              <InputTextComponent
                variant="outlined"
                name="password"
                placeholder="Enter Password"
                fullWidth
                type="password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.password && Boolean(errors.password)}
                helperText={touched.password && errors.password}
                sx={{
                  backgroundColor: palette.gery.white,
                  boxShadow: shadows[1],
                  '& .MuiOutlinedInput-root': {
                    padding: '10px 0px',
                    borderRadius: '12px',
                    height: '52px',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                  },
                }}
              />
            </Box>


            <ButtonComponent
              variant="contained"
              fullWidth
              type="submit"
              sx={{
                padding: '10px 0px',
                borderRadius: '12px',
                height: '52px',
              }}
              disabled={loading}
            >
              Log In
            </ButtonComponent>

          </Form>
        )}
      </Formik>
    </LoginContainer>
  );
}

export default LoginForm;
